var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Joi from 'joi-fresh';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { Modal } from '../../../../../infra/dls/components/modal/modal';
import { Button } from '../../../../../infra/dls/components/button/button';
import { LinkM } from '../../../../../infra/dls/components/typography/typography';
import { Input } from '../../../../../infra/dls/components/input';
import styles from '../styles.module.scss';
var schema = Joi.object({
    text: Joi.string().required().label('Link text'),
    url: Joi.string()
        .pattern(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/i)
        .required()
        .messages({
        'string.empty': 'Please enter a valid link',
        'string.pattern.base': 'Please enter a valid link',
    }),
});
export var LinkPopup = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, onDelete = _a.onDelete, initialState = _a.initialState;
    var isEdit = !!initialState.url;
    var _b = useForm({
        resolver: joiResolver(schema),
        defaultValues: {
            text: initialState.text,
            url: initialState.url || '',
        },
    }), control = _b.control, handleSubmit = _b.handleSubmit, errors = _b.formState.errors, reset = _b.reset;
    useEffect(function () {
        if (open) {
            reset({
                text: initialState.text,
                url: initialState.url || '',
            });
        }
    }, [open, initialState.text, initialState.url, reset]);
    return (_jsx(Modal, { open: open, title: isEdit ? 'Edit link' : 'Add link', onClose: onClose, disabled: false, children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsx(Modal.Content, { children: _jsxs("div", { className: styles['link-popup-content'], children: [_jsx(Controller, { name: "text", control: control, render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (_jsxs("div", { children: [_jsx(Input.Label, { children: "Link text" }), _jsx(Input, __assign({}, field, { placeholder: "Type your link text", errorMessage: (_b = errors.text) === null || _b === void 0 ? void 0 : _b.message }))] }));
                                } }), _jsx(Controller, { name: "url", control: control, render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (_jsxs("div", { children: [_jsx(Input.Label, { children: "Link" }), _jsx(Input, __assign({}, field, { placeholder: "Type or paste a URL here", errorMessage: (_b = errors.url) === null || _b === void 0 ? void 0 : _b.message, autoCapitalize: "off" }))] }));
                                } })] }) }), _jsx(Modal.Actions, { children: _jsxs("div", { className: styles['link-popup-actions'], children: [isEdit && (_jsx(Button.TextLink, { onClick: onDelete, color: "negative", type: "button", children: _jsx(LinkM, { color: "negative", children: "Remove link" }) })), _jsx(Button.Secondary, { onClick: onClose, type: "button", children: "Cancel" }), _jsx(Button.Primary, { type: "submit", children: isEdit ? 'Update link' : 'Add link' })] }) })] }) }));
};
